import useFetchIntegrationAgencySettings from 'hooks/useFetchIntegrationAgencySettings';
import {
  ConnectionConfigType,
  IntegrationEnum,
  IntegrationStatus,
} from 'models/InternalIntegrationSetting';

const useShouldRedirectToIntegrationsList = (id: IntegrationEnum) => {
  const { data: integrationAgencySettings, isLoading } =
    useFetchIntegrationAgencySettings({
      enumId: id,
    });

  const isWrongIntegrationType =
    !isLoading &&
    integrationAgencySettings?.integration?.connectionConfig.type !==
      ConnectionConfigType.OUTBOUND_OAUTH;

  const isStatusNotInactive =
    !isLoading &&
    integrationAgencySettings?.agencySettings?.status !==
      IntegrationStatus.INACTIVE;

  return isStatusNotInactive || isWrongIntegrationType;
};

export default useShouldRedirectToIntegrationsList;
